/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SortOrder } from "./SortOrder";
export type RawMaterialSort = {
  field: RawMaterialSort.field;
  /**
   * Sort order for the field
   */
  order?: SortOrder;
};
export namespace RawMaterialSort {
  export enum field {
    UPDATED_AT = "updated_at",
    SUPPLIER_MANUFACTURER = "supplier_manufacturer",
    TRADE_NAME = "trade_name",
  }
}
